import { useContext } from 'react';

import DataContext from '../store/dataContext';
import useCurrency from '../modules/currency/hooks/use-currency';

const useCartTotalsUtils = () => {
  const { cartDetails, cartTotals, applyStoreCredit, apiEmailResponse, giftCertificates } = useContext(DataContext);

  const { getShoppercurrency } = useCurrency();

  const shouldRenderBilledInUSD = () =>
    getShoppercurrency() &&
    Object.keys(getShoppercurrency()).length > 0 &&
    getShoppercurrency().code !== 'USD' &&
    !getShoppercurrency().isTransactional;

  const getOrderTotal = () => {
    const detailsSubtotal = cartDetails?.subtotal - (cartDetails?.coupons?.[0]?.amount || 0);
    if (
      (!applyStoreCredit && giftCertificates && giftCertificates.length > 0) ||
      (!applyStoreCredit && cartTotals?.data?.coupons && cartTotals?.data?.coupons?.length > 0)
    ) {
      return cartTotals.data?.grandTotal;
    }
    const store =
      applyStoreCredit && apiEmailResponse?.availableStoreCredit ? apiEmailResponse?.availableStoreCredit : 0;
    const total = (cartTotals.data?.total || cartTotals.data?.grandTotal || detailsSubtotal) - store;
    if (total <= 0 && applyStoreCredit) {
      return 0;
    }
    return (cartTotals.data?.total || cartTotals.data?.grandTotal || detailsSubtotal) - store;
  };

  return { shouldRenderBilledInUSD, getOrderTotal };
};

export default useCartTotalsUtils;
